export default __webpack_public_path__ + "static/media/crosspng.5acfc698.png";